<template>
  <div class="main-page-store-list-container" v-if="restaurant_data && !refresh">

    <div :class="!isMobile ? 'desktop-view' : 'mobile-view'">
      <h2 class="order-now" v-if="displayList.length>0">Turkish Restaurants Near Me</h2>
      <h2 class="order-now" v-else>Discover the Exquisite Flavors of Turkey: <br>
        Your Ultimate Destination for Authentic Turkish Cuisine Awaits at the Finest Turkish Restaurant Near You</h2>
      <div class="store-list-bottom">

          <div class="store-item open-store swiper-slide cursor-pointer" v-if="displayList" v-for="(item, index) in displayList" :key="index" @click="cartButtonClicked(item)">
            <div class="store-order-button" @click="cartButtonClicked(item)">Start Order</div>
            <div class="store-image store-image-open " v-bind:style="{ 'background-image': 'url('.concat(item.photoUrl).concat(')') }" @click="cartButtonClicked(item)">
            </div>
            <div class="store-detail" @click="cartButtonClicked(item)">
              <div class="store-title"><h2>{{ item.user_property['Restaurant-Name'] }}</h2></div>
              <div class="store-address">{{ item.user_property['Address'] }}</div>
            </div>
          </div>


      </div>
      <!-- CATERING START -->
      <div class="about-row col-rev-mob catering-box">

      <div class="about-col">
        <div>

          <h2>Catering for your event</h2>
          <p>
            Want great food for your event? It's easy! First, choose your favorite dishes to make your order. Then, send us your order. We will work out the best price for you, with no hidden costs. So why wait? Start your order now and get ready to enjoy delicious food at a good price!
          </p>
          <a @click="$router.push({path: '/catering'})" ><div class="claim-button mt-2" role="button">Order Catering</div></a>
        </div>
      </div>
      <div class="about-col img catering">
      <div role="button" class="store-order-button" @click="$router.push({path: '/catering'})">Order Catering</div>
    </div>
    </div>
      <!-- CATERING END -->
      <h2 class="coming-soon">Halal Restaurants </h2>
      <div class="store-list-bottom">

          <div class="store-item swiper-slide cursor-pointer" v-for="(item, index) in closed_restaurant_data" :key="index" @click="cartButtonClicked(item)">
            <div class="store-image" v-bind:style="{ 'background-image': 'url('.concat(item.photoUrl).concat(')') }" @click="cartButtonClicked(item)"></div>
            <div class="store-detail row" @click="cartButtonClicked(item)">
              <div class="store-title col-12"><h2 style="margin-bottom: 3px !important;">{{ item.user_property['Restaurant-Name'] }}</h2></div>
              <div class="store-address col-12">{{ item.user_property['Address'] }}</div>
              <div class="col-12 row" style="margin-top: 15px; margin-left: 0">
                <StarRating :rating="item.review" />
              </div>
            </div>
          </div>
          <div v-if="[1, 2].includes(closed_restaurant_data.length%3)"  class="store-item swiper-slide cursor-pointer"  @click="contactClicked()">
            <img class="store-image" :src="require('@/assets/images/restaurant-logos/like_tobe_here.png')" @click="contactClicked()" alt=""/>
            <div class="store-detail" @click="contactClicked()">
              <div class="store-title"><h2>Do you have a restaurant?</h2></div>
              <div class="store-address">Add Your Restaurant Here!</div>
            </div>
          </div>
          <div v-if="[1].includes(closed_restaurant_data.length%3) && !isMobile" class="store-item swiper-slide cursor-pointer"  @click="contactClicked()">
            <img class="store-image" :src="require('@/assets/images/restaurant-logos/like_tobe_here2.png')" @click="contactClicked()" alt=""/>
            <div class="store-detail" @click="contactClicked()">
              <div class="store-title"><h2>Do you have a restaurant?</h2></div>
              <div class="store-address">Add Your Restaurant Here!</div>
            </div>
          </div>
      </div>

      <h2 class="coming-soon">RESTAURANT BUSINESS FOR SALE </h2>
      <div class="store-list-bottom">
          <div class="store-item restaurant-sale swiper-slide cursor-pointer" v-for="(item, index) in restaurantSales" :key="index" @click="clickedRestaurantSales(item)">
            <img class="store-image" :src="require('@/assets/images/restaurant-logos/restaurant_sales.png')" @click="clickedRestaurantSales(item)" alt=""/>
            <div class="store-detail" @click="clickedRestaurantSales(item)">
              <div class="store-title"><h2>{{ item.name }}</h2></div>
              <div class="store-address">{{item.location}}</div>
              <div class="store-info">
                <div class="store-info-item">
                  <span class="fas fa-chair"></span>
                  <span style="padding-left: 5px">{{item.chair}} Chairs</span>
                </div>
                <div class="store-info-item">
                  <span class="fas fa-user-clock"></span>
                  <span style="padding-left: 5px">{{item.remaining_lease}}</span>
                </div>
              </div>
            </div>
          </div>

      </div>
    </div>
    <restaurant-sale-form-popup v-if="restaurantSaleModal" :is-sidebar-active="restaurantSaleModal" @closeSidebar="toggleRestaurantSaleModal" :restaurantSaleId="restaurantSaleId"/>
  </div>
</template>
<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import RestaurantSaleFormPopup from './RestaurantSaleFormPopup.vue'
import StarRating from '../../restaurantlist/components/StarRating.vue'
export default {
  name: 'TabsAllNew',
  data () {
    return {
      currentIndex: 0,
      itemsPerPage: 2,
      isPauseSlider: false,
      restaurant_data: null,
      closed_restaurant_data: null,
      restaurantSales: null,
      image_height: 0,
      image_width: 0,
      location: null,
      gettingLocation: false,
      errorStr: null,
      areaRestaurants: null,
      geocoder: null,
      pageCount: 0,
      maxItems: 0,
      refresh: false,
      restaurantSaleModal: false,
      claimPopup: false,
      restaurantSaleId: null,
      swiperOptionComingSoon: {
        slidesPerView: 3,
        spaceBetween: 10,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        speed: 300,
        loop: false,
        pagination: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints:{
          768: {
            slidesPerView: 2
          },
          540: {
            slidesPerView: 1
          }
        }
      },
      swiperOptionRec: {
        slidesPerView: 2,
        spaceBetween: 10,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        speed: 300,
        loop: false,
        pagination: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints:{
          768: {
            slidesPerView: 2
          },
          540: {
            slidesPerView: 1
          }
        }
      }
    }
  },
  mounted () {
    this.areaRestaurants = false
    this.getRestaurantList()
    this.getClosedRestaurantList()
    this.getMediterraneanRestaurantList()
  },
  watch: {
    refresh () {
      if (this.refresh) {
        const self = this
        setTimeout(() => {
          self.refresh = false
        }, 0)
        //self.$refs.rest_list.scrollIntoView({ behavior: 'smooth' })
      }
    },
    pageCount () {
      this.getRestaurantList()
    }
  },
  components: {
    ItemGridView: () => import('../../restaurantlist/components/ItemGridView.vue'),
    ItemListView: () => import('../../restaurantlist/components/ItemListView.vue'),
    swiper,
    swiperSlide,
    RestaurantSaleFormPopup,
    StarRating
  },
  computed: {
    itemCount () {
      if (this.isMobile)  {
        return 0
      } else {
        return 0
      }
    },
    isMobile () { return this.$store.state.api.isMobile },
    displayList () {
      const array = JSON.parse(JSON.stringify(this.all_restaurants))
      if (array) return array
      else return []
    },
    pageArray () {
      //const array = JSON.parse(JSON.stringify(this.all_restaurants))
      const page_array = []
      let i = 0
      const max_page = Math.floor(this.maxItems / this.itemCount)
      for (i = 0; i < max_page; i++) {
        page_array.push(parseInt(i) + 1)
      }
      const kalan = Math.floor(this.maxItems % this.itemCount)
      if (kalan > 0) {
        page_array.push(max_page + 1)
      }
      return page_array
    },
    split_pagination () {
      const arr = this.pageArray
      const result = []
      if (arr.length > 5) {
        if (this.pageCount < arr.length - 2 && this.pageCount > 1) {
          result.push('...')
          result.push(this.pageCount)
          result.push(this.pageCount + 1)
          result.push(this.pageCount + 2)
          result.push('...')
          //result.push(arr.length)
        } else if (this.pageCount < 3) {
          result.push(arr[0])
          result.push(arr[1])
          result.push(arr[2])
          result.push('...')
          result.push(arr.length)
        } else {
          result.push(arr[0])
          result.push('...')
          result.push(arr.length - 2)
          result.push(arr.length - 1)
          result.push(arr.length)
        }
        return result
      } else {
        return arr
      }
    },
    all_restaurants () {
      return this.restaurant_data.data
    },
    restaurantlist () {
      return this.$store.state.api.restaurantlistall
    },
    deliveryAddress () {
      return this.$store.state.api.deliveryAddress
    }
  },
  methods: {
    toggleRestaurantSaleModal (val = false) {
      this.restaurantSaleModal = val
      if (!val) {
        // this.refresh_product = true
      }
    },
    pageDoubleUp () {
      if (this.pageCount < this.pageArray.length - 3) {
        this.pageCount += 3
      }
    },
    pageFirst () {
      this.pageCount = 0
    },
    pageLast () {
      this.pageCount = this.pageArray.length - 1
    },
    pageDoubleDown () {
      if (this.pageCount !== 0 && this.pageCount !== 1) {
        this.pageCount -= 3
      }
    },
    pageUp () {
      if (this.pageCount < this.pageArray.length - 1) {
        this.pageCount += 1
      }
    },
    pageDown () {
      if (this.pageCount !== 0) {
        this.pageCount -= 1
      }
    },
    async locationToShow () {
      const isLoggedIn = await this.$store.state.api.isUserLoggedIn()
      if (isLoggedIn) {

        if (this.deliveryAddress.id !== 0) {
          const address_str = `${this.deliveryAddress.address} ${this.deliveryAddress.city} ${this.deliveryAddress.region} ${this.deliveryAddress.post_code}`
          this.getAddressLocation(address_str, (result) => {
            this.location = [result[0].geometry.location.lat(), result[0].geometry.location.lng()] //[customer_loc.coords.latitude, customer_loc.coords.longitude]
            this.getHomeRestaurantList()
          })
        } else {

          const customer_loc = await this.getLocation()
          this.areaRestaurants = false
          try {
            this.gettingLocation = false
            this.location = [customer_loc.coords.latitude, customer_loc.coords.longitude]
            this.areaRestaurants = true
            this.getHomeRestaurantList()
          } catch (e) {
            this.gettingLocation = false
            this.errorStr = e.message
            this.areaRestaurants = false
            this.getRestaurantList()
            this.getClosedRestaurantList()
            this.getMediterraneanRestaurantList()
          }
        }
      } else {
        const customer_loc = await this.getLocation()

        try {
          this.gettingLocation = false
          this.location = [customer_loc.coords.latitude, customer_loc.coords.longitude] //
          this.areaRestaurants = true
          this.getHomeRestaurantList()
        } catch (e) {
          this.gettingLocation = false
          this.errorStr = e.message
          this.areaRestaurants = false
          this.getRestaurantList()
          this.getClosedRestaurantList()
          this.getMediterraneanRestaurantList()
        }
      }
    },
    async getLocation () {

      return new Promise((resolve, reject) => {
        if (!('geolocation' in navigator)) {
          reject(new Error('Geolocation is not available.'))
        }

        navigator.geolocation.getCurrentPosition(pos => {
          resolve(pos)
        }, err => {
          reject(err)
        })

      })
    },
    paginate_click (page, index) {
      if (page === '...') {
        if (index === this.split_pagination.length - 2 || index === this.split_pagination.length - 1) {
          this.pageDoubleUp()
        } else {
          this.pageDoubleDown()
        }
      } else {
        this.pageCount = page - 1
      }
    },
    cartButtonClicked (item) {
      window.location.href = `/restaurants/${String(item.user_property['Alias'])}`
      /*this.$router.push({
        name: 'restaurant-products',
        params: {
          restaurant_id: String(item.user_property['Alias']),
          related_items: this.restaurantlist
        }})*/

    },
    clickedRestaurantSales (item) {
      this.restaurantSaleModal = true
      this.restaurantSaleId = item.id
      /*this.$router.push({
        name: 'restaurant-products',
        params: {
          restaurant_id: String(item.user_property['Alias']),
          related_items: this.restaurantlist
        }})*/

    },
    contactClicked () {
      this.$vs.loading()
      this.$router.push({path: '/contact'}).then(() => {
        this.$vs.loading.close()
      })
    },
    getRestaurantList () {
      const payload = {
        page: this.pageCount + 1,
        limit: this.itemCount
      }

      this.$store.dispatch('api/getRestaurantListAll', payload)
        .then((response) => {
          this.restaurant_data = response.data
          this.maxItems = this.restaurant_data.total
          this.refresh = true
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    getClosedRestaurantList () {
      const payload = {
        page: 1,
        limit: 0,
        closed: 1
      }

      this.$store.dispatch('api/getRestaurantListAll', payload)
        .then((response) => {
          this.closed_restaurant_data = response.data.data

        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    getMediterraneanRestaurantList () {
      const payload = {
        page: 1,
        limit: 0
      }

      this.$store.dispatch('api/getRestaurantSales', payload)
        .then((response) => {
          this.restaurantSales = response.data.data
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    getHomeRestaurantList () {
      const payload = {
        lat: this.location[0],
        lng: this.location[1]
      }

      this.$store.dispatch('api/getHomeRestaurantList', payload)
        .then((response) => {
          this.restaurant_data = response.data
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getAddressLocation (address_text, callback) {
      const addressObj = {
        address: address_text,
        country: 'United States'
      }
      this.geocoder.geocode(addressObj, (response, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          callback(response)
        }
      })
    }
  }
}
</script>
<style lang="scss">

.swiper-container{
  margin-bottom:0 !important;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.main-page-store-list-container{
  h2 {
    margin:0px 0 10px 0;
  }
  margin-top:30px;
  .swiper-wrapper{
  padding:5px;
}
.order-now{
border-left:10px solid #f24405;
box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.1);
width:max-content;
padding:5px 15px;
}
.coming-soon{
  border-left:10px solid #f24405;
box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.1);
width:max-content;
padding:5px 15px;
margin-top:20px;
}
.h2-text{
  border-left:10px solid #f24405;
box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.1);
width:max-content;
padding:5px 15px;
margin-top:20px;
}
}
.desktop-view{
  width:100%;
  .store-list-top, .store-list-bottom{
    display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
    .store-item{
      box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.1);
      border-radius: 3px;
      align-self: flex-start;
      height: max-content;
      position: relative;
      .store-order-button{
        position:absolute;
        top:0;
        left:29%;
        transform: translate(80%, 0%);
        background-color:#ff6a1e;
        color:#fff;
        font-weight: 900;
        padding:5px 15px;
        font-size:24px;
      }
      .store-image{
        width:100%;
        height:300px;
        background-size: cover;
        background-position: center center;
      }
      .store-detail{
        padding:20px;
        .store-title{
          h2{
            font-size:22px;
            font-weight: 900;
          }
        }
        .store-address{
          font-size:13px;
          font-weight: 500;
          color:#3c3c3c;
        }
      }
    }
  }
  .store-list-bottom, .store-list-top{
    margin-top:20px;
    display:flex;
    //justify-content: space-between;
    .store-item{
      height: max-content;
      box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.1);
      border-radius: 3px;
      .store-image{
        width:100%;
        height:200px;
        background-size: cover;
        background-position: center center;
      }
      .store-detail{
        padding:20px;
        .store-title{
          h2{
            font-size:16px;
            font-weight: 900;
          }
        }
        .store-address{
          font-size:13px;
          font-weight: 500;
          color:#3c3c3c;
        }
      }
    }
  }
  #swiper-wrapper-top{
          .store-image{
            height:400px;
          }
        }
}

.mobile-view{
  width:100%;
  .about-col.img.catering{
  position:relative;
  .store-order-button{
    position:absolute;
        top:0;
        transform: translate(65%, 0%);
        background-color:#f24405;
        color:#fff;
        font-weight: 900;
        padding:5px 3px;
        font-size:18px;
  }
}
  .store-list-top {
    display: grid;
  grid-template-columns: 1fr;
  gap:20px;
  }
  .store-list-bottom{
    display:flex;
    justify-content: flex-start;
    gap:15px;
  }
  .store-list-top, .store-list-bottom{
    .store-item{
      height: max-content;
      box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.1);
      border-radius: 3px;
      position: relative;
      .store-order-button{
        position:absolute;
        top:0;
        transform: translate(82%, 0%);
        background-color:#ff6a1e;
        color:#fff;
        font-weight: 900;
        padding:5px 3px;
        right: 80px;

        font-size:18px;
      }
      .store-image{
        width:100%;
        height:100px;
        background-size: cover;
        background-position: center center;
      }
      .store-image-open {
        height:200px;
      }
      .store-detail{
        padding:15px;
        .store-title{
          h2{
            font-size:16px;
            font-weight: 900;
          }
        }
        .store-address{
          font-size:13px;
          font-weight: 500;
          color:#3c3c3c;
        }
      }
    }
  }
  .store-list-top{
    .store-item{
    .store-image{
        height:150px;
      }
    }
  }
  #swiper-wrapper-top{
          .store-image{
            height:200px;
          }
        }

}
.swiper-button-prev {
  left: 15px;
}
.swiper-button-prev, .swiper-button-next {
  margin-top: 0;
  cursor: pointer;
  transform: scale(.5);
  background: white;
  color: #626262;
  border-radius: 6px;
  padding: 35px 30px;
  top: calc(235px - var(--swiper-navigation-size)/2);
}
.slider-bottom.swiper-button-prev, .slider-bottom.swiper-button-next {
        top: calc(100px - var(--swiper-navigation-size)/2) !important;
      }

@media (max-width:768px){
  .slider-bottom.swiper-button-prev, .slider-bottom.swiper-button-next {
        top: calc(42px - var(--swiper-navigation-size)/2) !important;
      }
      .main-page-store-list-container{
        margin-top:10px;
      }
}

@media (max-width:820px)  {
  .store-address{
    //display:none;
  }
}

.store-item {
  width:32%
}
.store-list-top, .store-list-bottom {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  gap: 24px;
}

@media (max-width:820px){
  .store-item {
    width: calc(50% - 10px);
    margin-bottom: 5px;
  }
  .open-store {
    width: calc(100% - 10px);
  }
  .store-image{
    min-height:75px;
  }
  .store-detail{
    min-height: auto;
  }
  .store-list-top {
    padding: 15px 0 0 0;
    margin-bottom:0px;
  }
  .store-list-bottom {
    padding: 15px 0 0 0;
    margin-bottom:0px;
  }
}
.store-info-item {
  float: left;
  padding-right: 10px
}
.restaurant-sale {
  padding-bottom: 20px;
}
</style>
